import { Plus, Upload } from "lucide-react";
import { Link } from "@tanstack/react-router";

export interface BillListHeaderProps {
  lead: string | null;
  canCreate?: boolean;
}

export function BillListHeader({ lead, canCreate = true }: BillListHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold text-ink">Bills</h1>
        <p className="mt-1 text-sm text-muted">{lead ?? "Loading bill summary…"}</p>
      </div>
      {canCreate && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          <Link
            to="/procurement/bills/new"
            className="inline-flex h-10 items-center gap-2 rounded-md border border-line bg-paper px-3 text-sm font-semibold text-ink-2 shadow-sm transition hover:border-line-2 hover:bg-bg"
          >
            <Upload size={15} aria-hidden />
            Upload bill
          </Link>
          <Link
            to="/procurement/bills/new"
            className="inline-flex h-10 items-center gap-2 rounded-md bg-ink px-3 text-sm font-semibold text-white shadow-sm transition hover:bg-ink-2"
          >
            <Plus size={15} aria-hidden />
            New bill
          </Link>
        </div>
      )}
    </div>
  );
}
